import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Box, Button, Typography } from "@mui/material";

const MyQRScanner = ({onScan}) => {
    const [scanning, setScanning] = useState(false);
    const [result, setResult] = useState("");
    const [error, setError] = useState("");
    const qrCodeRegionId = "qr-reader";
    const html5QrCodeRef = useRef(null);

    const handleScanSuccess = (decodedText) => {
        setResult(decodedText);
        if (onScan) onScan(decodedText); // <-- Dispara callback externo
        stopScan();
    };

    const startScan = async () => {
        setResult("");
        setError("");
        setScanning(true);

        try {
            html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);

            await html5QrCodeRef.current.start(
                { facingMode: "environment" },
                { fps: 10, qrbox: { width: 250, height: 250 } },
                handleScanSuccess,
                (err) => console.warn("Escaneo fallido:", err)
            );
        } catch (err) {
            setError("Error al acceder a la cámara.");
            console.error(err);
            setScanning(false);
        }
    };

    const stopScan = async () => {
        if (html5QrCodeRef.current) {
            await html5QrCodeRef.current.stop();
            await html5QrCodeRef.current.clear();
            html5QrCodeRef.current = null;
        }
        setScanning(false);
    };

    useEffect(() => {
        return () => {
            stopScan(); // Limpieza al desmontar
        };
    }, []);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 3 }}>
           {/*  <Typography variant="h5" gutterBottom>
                Escáner de Código QR
            </Typography> */}

            <Box
                id={qrCodeRegionId}
                sx={{
                    width: 300,
                    height: 300,
                    border: scanning ? "1px solid #ccc" : "none",
                    borderRadius: 2,
                    mb: 2,
                    display: scanning ? "block" : "none",
                }}
            />

            {scanning ? (
                <Button variant="contained" color="error" onClick={stopScan}>
                    Detener escaneo
                </Button>
            ) : (
                <Button variant="contained" onClick={startScan}>
                    Iniciar escaneo
                </Button>
            )}
            
            {error && (
                <Typography variant="body2" color="error" mt={2}>
                    ⚠️ {error}
                </Typography>
            )}
        </Box>
    );
};

export default MyQRScanner;